// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Horse {
	height: 100%;
	width: 10vw;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: 2s;
	position: absolute;
}

.Horse img {
	position: absolute;
	height: 90%;
	object-fit: cover;
	overflow: visible;
}

@keyframes finish {
	0% {
		z-index: 10;
		transform: translateY(0) rotate(0deg);
	}
	50% {
		transform: translateY(-100px) rotate(180deg);
	}
	75% {
		transform: translateY(-100px) rotate(420deg);
	}
	90% {
		transform: translateY(100vh) rotate(420deg);
	}
	91% {
		z-index: 0;
		transform: translateY(10vh) rotate(0);
	}
	100% {
		transform: translateY(0) rotate(0);
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Horse.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC;EACC,WAAW;EACX,qCAAqC;CACtC;CACA;EACC,4CAA4C;CAC7C;CACA;EACC,4CAA4C;CAC7C;CACA;EACC,2CAA2C;CAC5C;CACA;EACC,UAAU;EACV,qCAAqC;CACtC;CACA;EACC,kCAAkC;CACnC;AACD","sourcesContent":[".Horse {\n\theight: 100%;\n\twidth: 10vw;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttransition: 2s;\n\tposition: absolute;\n}\n\n.Horse img {\n\tposition: absolute;\n\theight: 90%;\n\tobject-fit: cover;\n\toverflow: visible;\n}\n\n@keyframes finish {\n\t0% {\n\t\tz-index: 10;\n\t\ttransform: translateY(0) rotate(0deg);\n\t}\n\t50% {\n\t\ttransform: translateY(-100px) rotate(180deg);\n\t}\n\t75% {\n\t\ttransform: translateY(-100px) rotate(420deg);\n\t}\n\t90% {\n\t\ttransform: translateY(100vh) rotate(420deg);\n\t}\n\t91% {\n\t\tz-index: 0;\n\t\ttransform: translateY(10vh) rotate(0);\n\t}\n\t100% {\n\t\ttransform: translateY(0) rotate(0);\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
